import { ApiEnv } from '../config.types';

export const selectValueByApiEnv = (data: { [key in ApiEnv]: string }) => data[process.env.API_ENV];
